import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Yard Management Module Service Stores
 */
export const yardStores: ServiceStoreConfig[] = [
  {
    name: "yard-locations",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "yard-inventory-items",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "yard-movement-logs",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "yard-maps",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "yard-map-location-assignments",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
];